var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78608 5.91263C9.78608 8.1733 7.95345 10.0059 5.69278 10.0059C3.43212 10.0059 1.59949 8.1733 1.59949 5.91263C1.59949 3.65197 3.43212 1.81934 5.69278 1.81934C7.95345 1.81934 9.78608 3.65197 9.78608 5.91263ZM9.32511 10.1661C8.34783 11.0015 7.07922 11.5059 5.69278 11.5059C2.60369 11.5059 0.0994873 9.00173 0.0994873 5.91263C0.0994873 2.82354 2.60369 0.319336 5.69278 0.319336C8.78188 0.319336 11.2861 2.82354 11.2861 5.91263C11.2861 7.07579 10.931 8.15603 10.3234 9.05087C10.347 9.06936 10.3697 9.08946 10.3914 9.11117L13.6808 12.4006C13.9737 12.6935 13.9737 13.1684 13.6808 13.4612C13.3879 13.7541 12.913 13.7541 12.6201 13.4612L9.33072 10.1718C9.32884 10.1699 9.32697 10.168 9.32511 10.1661Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.7ab6ecd2c04c5986d5e9c9fc4349ec22.svg";
export { ForwardRef as ReactComponent };